import React, { useEffect } from "react";
import ApiConnect from "../../../../../Utils/ApiConnect";
import { useDispatch, useSelector } from "react-redux";

import { Accordion, Card, useAccordionButton } from "react-bootstrap";

function CustomToggle({ children, eventKey }) {
  const decoratedOnClick = useAccordionButton(eventKey);
  return (
    <div className="row w-100" onClick={decoratedOnClick}>
      {children}
    </div>
  );
}
function RoleInformation() {
  const UserRoleData = useSelector((state) => state.Utilities.Roles);
  const dispatch = useDispatch();
  const fetchUserRole = () => {
    ApiConnect.get("/Module/Utilities/Users/UserRolesDetails")
      .then((response) => {
        let Roles = response.data;
        dispatch({ type: "SET_UTILITIES_ROLES", payload: { Roles } });
      })
      .catch((error) => console.log(error));
  };
  useEffect(() => {
    fetchUserRole();
  }, []);

  function getIcon(theme) {
    switch (theme.toUpperCase()) {
      case "DASHBOARD":
        return <span className="material-icons text-success">dashboard</span>;
        break;
      case "POS":
        return (
          <span className="material-icons text-success">point_of_sale </span>
        );
        break;
      case "WAITER":
        return (
          <span className="material-icons text-success">emoji_people</span>
        );
        break;
      case "BAR":
        return <span className="material-icons text-success">nightlife</span>;
        break;
      case "KITCHEN":
        return <span className="material-icons text-success">kitchen</span>;
        break;
    }
  }
  return (
    <>
      {" "}
      <Accordion defaultActiveKey="0">
        {UserRoleData.map((role, index) => (
          <Card key={index}>
            <Card.Header>
              <CustomToggle eventKey={role.id}>
                <h4 className="col card-title">{role.name}</h4>
                <h4 className="col card-title d-flex flex-row">
                  <span className="material-icons text-success">people</span>
                  {role.users}
                </h4>
                <h4 className="col card-title d-flex flex-row">
                  {role.dashboard.map((dash, dashkey) => (
                    <React.Fragment key={dashkey}>
                      {getIcon(dash)}
                    </React.Fragment>
                  ))}
                  <span className="material-icons text-danger">https</span>
                  {role.Auth}
                </h4>
              </CustomToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={role.id}>
              <Card.Body>
                <ul className="list-unstyled list-inline">
                  {role.roles.map((menu, menuIndex) => (
                    <li className="list-inline-item p-3" key={menuIndex}>
                      <h5>
                        <strong>{menu.name}</strong>
                      </h5>
                      <ul className="list-group-item">
                        {menu.submenu.map((sub, subIndex) => (
                          <li className="list-group-item b-0" key={subIndex}>
                            <span className="title">{sub.name}</span>
                          </li>
                        ))}
                      </ul>
                    </li>
                  ))}
                </ul>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        ))}
      </Accordion>
    </>
  );
}
export default RoleInformation;
